import React from "react";
import "./FreeText.scss";
import { FreeTextConfig } from "./FreeTextConfig";

export default function FreeText(props: FreeTextConfig) {
  return (
    <div
      className="quill-rendered-content bg-white"
      style={{ height: `${props.height ?? "auto"}px` }}
    >
      <div
        dangerouslySetInnerHTML={{
          __html: props.useHTMLCode ? (props.htmlContent ?? "") : (props.content ?? ""),
        }}
      />
    </div>
  );
}